import { adminVerificationQueryKeys as e } from "./adminVerificationQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { verificationApi as r } from "@maat/api-main";
//#region src/verification/admin/useReviewIdentityMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ userId: e, payload: t }) => r.reviewIdentityVerification(e, t),
		onSuccess: (t, { userId: n }) => {
			i.invalidateQueries({ queryKey: e.list() }), i.invalidateQueries({ queryKey: e.detail("identity", n) });
		}
	});
};
//#endregion
export { i as useReviewIdentityMutation };
